module.exports = __webpack_public_path__ + "assets/714bac95ff653ad2edc5f66d3b34323e.svg";